<form [formGroup]="newAltAddressForm">
<div class="edit-alt-address-dialog">
    <div>  <p class="alt-ship-to-header-text section-headers">ALT.SHIP-TO ADDRESS</p></div>
    <div><p class="">Add your alternative Ship-to address</p></div>

    <div class="alt-ship-inputs-container">

    <div class="alt-ship-inputs-container-left">
        <div class="alt-ship-inputs">
            <mat-form-field class="alt-ship-cal-input alt-add-input-space" appearance="outline">
                <mat-label>Address Line 1</mat-label>
                <input matInput formControlName="addressLine1" autofocus>
            </mat-form-field>
        </div>

        <div class="alt-ship-inputs">
            <mat-form-field class="alt-ship-cal-input alt-add-input-space" appearance="outline">
                <mat-label>Address Line 3</mat-label>
                <input matInput formControlName="addressLine3">
            </mat-form-field>
        </div>

        <div class="alt-ship-inputs">
            <mat-form-field class="alt-ship-cal-input alt-add-input-space" appearance="outline">
                <mat-label>Province</mat-label>
                <input matInput formControlName="province">
            </mat-form-field>
        </div>

    </div>

    <div class="alt-ship-inputs-container-right">

        <div class="alt-ship-inputs">
            <mat-form-field class="alt-ship-cal-input alt-add-input-space" appearance="outline">
                <mat-label>Address Line 2</mat-label>
                <input matInput formControlName="addressLine2">
            </mat-form-field>
        </div>

        <div class="alt-ship-inputs">
            <mat-form-field class="alt-ship-cal-input alt-add-input-space" appearance="outline">
                <mat-label>Town</mat-label>
                <input matInput formControlName="town">
            </mat-form-field>
        </div>

        <div class="alt-ship-inputs">
            <mat-form-field class="alt-ship-cal-input alt-add-input-space" appearance="outline">
                <mat-label>Postal Code</mat-label>
                <input matInput formControlName="postalCode">
            </mat-form-field>
        </div>

    </div>

    </div>

    <div class="alt-ship-action-btn-container">
        <div class="cancel-alt-btn-container">
            <button class="cancel-alt-btn" mat-flat-button type="button" (click)="cancelAddingAltAddress()">
                <div class="cancel-alt-btn-content">
                    <span><p class="cancel-alt-btn-text">CANCEL</p></span>
                </div>
            </button>
        </div>

        <div class="add-alt-btn-container">
            <button class="add-alt-btn" mat-flat-button type="button" (click)="addNewAltAddress()">
                <div class="add-alt-btn-content">
                    <span><p class="add-alt-btn-text">ADD</p></span>
                </div>
            </button>
        </div>

    </div>

</div>

</form>